import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.parse-int.js";
/* eslint-disable no-underscore-dangle */
import cookie from 'react-cookies';
var computeTTL = function computeTTL(token_expiry_value) {
  var current_time = new Date().getTime();
  var expiry_time;
  if (token_expiry_value) {
    expiry_time = parseInt(token_expiry_value, 10) * 1000;
  } else {
    expiry_time = current_time;
  }
  // Prevent negative TTL
  if (expiry_time < current_time) {
    expiry_time = current_time;
  }
  return (expiry_time - current_time) / 1000;
};
var abjwt = {
  _get_refresh_token_expiry: function _get_refresh_token_expiry() {
    return cookie.load('abjwt_refresh_token_expiry');
  },
  isLoggedIn: function isLoggedIn() {
    return computeTTL(abjwt._get_refresh_token_expiry()) > 0;
  }
};
export { abjwt };